import React from "react";
import HeroParallax from "../components/HeroParallax";
import ProjectsSection from "../components/ProjectsSection";
import StorySection from "../components/StorySection";
import AmenitiesSection from "../components/AmenitiesSection";
import InspirationsSection from "../components/InspirationsSection";
import TestimonialsSection from "../components/TestimonialsSection";
import FAQSection from "../components/FAQSection";
import CTASection from "../components/CTASection";

export default function HomePage() {
  return (
    <>
      <HeroParallax />
      <ProjectsSection />
      <StorySection />
      <AmenitiesSection />
      <InspirationsSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
    </>
  );
}
